import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const ChevronDown: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8294 4.62366L3.1709 5.37623L6.00015 7.85183L8.8294 5.37623L8.1709 4.62366L6.00015 6.52306L3.8294 4.62366Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronDown;
